<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="welcome-image"><a><span class="center"><img alt="CoverImage" src="images/9780446550376_c.jpg" title="Cover"/></span></a></p></div>
<p class="welcome"><a href="#/prologue"><span class="center"><strong>Begin Reading</strong></span></a></p>
<p class="welcome"><span href="#/toc" title="Link target outside of Sample"><span class="center">Table of Contents</span></span></p>
<p class="welcome"><span href="#/teaser001" title="Link target outside of Sample"><span class="center">A Preview of <em>Knight’s Treasure</em></span></span></p>
<p class="welcome"><span href="#/copyright" title="Link target outside of Sample"><span class="center">Copyright Page</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// welcome.vue?20ae53ea